import { z } from 'zod';
import { apiFetch } from './client';

const HealthResponseSchema = z.object({
  ok: z.boolean(),
  status: z.enum(['ok', 'degraded', 'down']),
  db: z.enum(['up', 'down']),
  redis: z.enum(['up', 'down']),
  metaCloudMode: z.enum(['mock', 'real']),
  uptimeSeconds: z.number().nonnegative(),
  timestamp: z.string().datetime(),
});

export type HealthResponse = z.infer<typeof HealthResponseSchema>;

export async function getHealth(signal?: AbortSignal): Promise<HealthResponse> {
  return apiFetch('/health', HealthResponseSchema, { signal });
}
